/**
 * Product Item Color Swatches JavaScript
 * Handles color switching, image updates, and add-to-cart functionality
 */

(function () {
  'use strict';

  class ProductSwatches {
    constructor() {
      this.init();
    }

    init() {
      document.addEventListener('DOMContentLoaded', () => {
        this.initSwatches();
        this.initSizeButtons();
        this.applyColorSwatches();
        this.scrollActiveSwatches(); // ✅ NEW
        this.initHoverImages();
        this.initImagePlaceholderCleanup();
      });
    }

    initSwatches() {
      const swatchItems = document.querySelectorAll('.swatch-item');

      swatchItems.forEach(swatch => {
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleColorClick(swatch);
        });
      });
    }

    // ✅ NEW - scroll helper
    // scrollSwatchIntoView(swatch, wrapper) {
    //   const scrollContainer = wrapper.querySelector('.product-swatches-scroll');
    //   const totalWidth = scrollContainer.scrollWidth;
    //   const visibleWidth = scrollContainer.clientWidth;
    //   const currentScroll = scrollContainer.scrollLeft;

    //   console.log('Total:', totalWidth);
    //   console.log('Visible:', visibleWidth);
    //   console.log('Scrolled:', currentScroll);
    //   if (!scrollContainer) return;

    //   const swatchRect = swatch.getBoundingClientRect();
    //   const containerRect = scrollContainer.getBoundingClientRect();

    //   const swatchCenter = swatchRect.left + (swatchRect.width / 2);
    //   const containerCenter = containerRect.left + (containerRect.width / 2);

    //   const scrollOffset = swatchCenter - containerCenter;
    //   const targetScrollLeft = scrollContainer.scrollLeft + scrollOffset;

    //   scrollContainer.scrollTo({
    //     left: targetScrollLeft,
    //     behavior: 'smooth'
    //   });
    // }
    scrollSwatchIntoView(swatch, wrapper) {
      const scrollContainer = wrapper.querySelector('.product-swatches-scroll');
      if (!scrollContainer) return;

      let left = 0;

      for (const item of scrollContainer.children) {
        if (item === swatch) break;
        left += item.offsetWidth;
        left += parseFloat(getComputedStyle(scrollContainer).gap || 0);
      }

      const swatchCenter = left + (swatch.offsetWidth / 2);
      const containerCenter = scrollContainer.clientWidth / 2;

      let targetScrollLeft = swatchCenter - containerCenter;

      const maxScroll =
        scrollContainer.scrollWidth - scrollContainer.clientWidth;

      targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScroll));

      scrollContainer.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    }



    // ✅ NEW - scroll active swatch on load
    scrollActiveSwatches() {
      document.querySelectorAll('.product-swatches-wrapper').forEach(wrapper => {
        const activeSwatch = wrapper.querySelector('.swatch-item.active');
        if (activeSwatch) {
          this.scrollSwatchIntoView(activeSwatch, wrapper);
        }
      });
    }

    handleColorClick(swatch) {
      const wrapper = swatch.closest('.product-swatches-wrapper');
      const productRoot = swatch.closest('.product--root');

      if (!wrapper || !productRoot) return;

      // Update active state
      wrapper.querySelectorAll('.swatch-item').forEach(item => {
        item.classList.remove('active');
      });

      swatch.classList.add('active');

      // ✅ NEW - scroll clicked swatch
      this.scrollSwatchIntoView(swatch, wrapper);

      // Get product data
      const productImage = swatch.dataset.productImage;
      const productUrl = swatch.dataset.productUrl;
      const productHandle = swatch.dataset.productHandle;

      // Update main product image
      if (productImage) {
        let imageElement = productRoot.querySelector('.product--image img');

        if (!imageElement) {
          imageElement = productRoot.querySelector('img[src*="cdn.shopify.com"]');
        }

        if (!imageElement) {
          const imageContainer = productRoot.querySelector('.product--image');
          if (imageContainer) {
            imageElement = imageContainer.querySelector('img');
          }
        }

        if (imageElement) {
          imageElement.src = productImage;

          if (imageElement.hasAttribute('srcset')) {
            imageElement.srcset = productImage;
          }

          if (imageElement.hasAttribute('data-src')) {
            imageElement.setAttribute('data-src', productImage);
          }
        }
      }

      // Update product link
      const productLink = productRoot.querySelector('a[href*="/products/"]');
      if (productLink && productUrl) {
        productLink.href = productUrl;
      }

      // Fetch sizes
      if (productHandle) {
        this.updateSizesForProduct(productHandle, wrapper);
      }
    }

    async updateSizesForProduct(productHandle, wrapper) {
      const sizesContainer = wrapper.querySelector('.product-sizes-container');
      if (!sizesContainer) return;

      try {
        const response = await fetch(`/products/${productHandle}.js`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const productData = await response.json();

        sizesContainer.innerHTML = '';

        const sizeOptionIndex = productData.options.findIndex(option => {
          return option?.name?.toLowerCase().includes('size');
        });

        if (sizeOptionIndex === -1) return;

        const sizes = new Set();

        productData.variants.forEach(variant => {
          const size = variant.options[sizeOptionIndex];
          if (size) sizes.add(size);
        });

        let isFirstAvailable = true;
        sizes.forEach(size => {
          const variant = productData.variants.find(v =>
            v.options[sizeOptionIndex] === size
          );

          if (variant) {
            const button = document.createElement('button');
            const shouldBeActive = variant.available && isFirstAvailable;
            button.className = `size-button ${shouldBeActive ? 'size-button-active' : ''} ${!variant.available ? 'disabled' : ''}`;
            button.dataset.variantId = variant.id;
            button.dataset.available = variant.available;
            button.textContent = size;

            if (!variant.available) {
              button.disabled = true;
            }

            if (shouldBeActive) {
              isFirstAvailable = false;
            }

            sizesContainer.appendChild(button);
          }
        });

        this.initSizeButtons();

      } catch (error) {
        console.error('Error fetching product data:', error);
      }
    }

    initSizeButtons() {
      const sizeButtons = document.querySelectorAll('.size-button:not(.disabled)');

      sizeButtons.forEach(button => {
        button.replaceWith(button.cloneNode(true));
      });

      document.querySelectorAll('.size-button:not(.disabled)').forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Toggle active class
          const sizesContainer = button.closest('.product-sizes-container');
          if (sizesContainer) {
            sizesContainer.querySelectorAll('.size-button').forEach(btn => {
              btn.classList.remove('active');
            });
            button.classList.add('active');
          }

          this.handleSizeClick(button);
        });
      });
    }

    async handleSizeClick(button) {
      const variantId = button.dataset.variantId;

      if (!variantId || button.classList.contains('loading')) return;

      button.classList.add('loading');
      const originalText = button.textContent;
      button.textContent = originalText;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!response.ok) {
          if (response.status === 429) throw new Error('Rate limited');
          throw new Error('Failed to add to cart');
        }

        button.textContent = originalText;

        if (window.theme?.cart?.fetchTotals) {
          await window.theme.cart.fetchTotals();
        }

        if (window.theme?.cart?.updateAllHtml) {
          await window.theme.cart.updateAllHtml();
        }

        if (window.theme?.settings?.cart_type === 'drawer') {
          if (window.theme?.off_canvas?.toggle) {
            window.theme.off_canvas.toggleView('cart');
            window.theme.off_canvas.toggle('right-sidebar');
          }
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));

        setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove('loading');
        }, 1500);

      } catch (error) {
        console.error('Error adding to cart:', error);

        button.textContent =
          error.message.includes('Rate limited') ? '⏱' : '✗';

        setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove('loading');
        }, 1500);
      }
    }

    /**
     * Remove inline background-color from image--root once an image has loaded.
     * CSS :has() already handles this in modern browsers; this is a JS fallback
     * for older browsers and also handles images loaded before this script runs.
     */
    initImagePlaceholderCleanup() {
      const clearWrapper = (wrapper) => {
        wrapper.style.removeProperty('background-color');
        wrapper.style.removeProperty('background');
        wrapper.style.removeProperty('animation');
        wrapper.style.removeProperty('background-size');
        wrapper.style.removeProperty('background-position-x');
        wrapper.style.removeProperty('overflow');
      };

      document.addEventListener('lazyloaded', (e) => {
        const wrapper = e.target.closest('.product--image-wrapper');
        if (wrapper) clearWrapper(wrapper);
      });

      // Also clean up any images that lazysizes already loaded before this ran
      document.querySelectorAll('.product--image-wrapper img.lazyloaded').forEach((img) => {
        const wrapper = img.closest('.product--image-wrapper');
        if (wrapper) clearWrapper(wrapper);
      });
    }

    /**
     * Lazy-load hover images: inject hover image HTML only on first mouseenter.
     * This prevents ALL hover images from being loaded on page load.
     */
    initHoverImages() {
      document.querySelectorAll('[data-hover-image="true"]').forEach(productRoot => {
        let hoverLoaded = false;

        productRoot.addEventListener('mouseenter', () => {
          if (hoverLoaded) return;

          const imageLink = productRoot.querySelector('.product--image[data-hover-src]');
          if (!imageLink) return;

          const hoverSrc = imageLink.dataset.hoverSrc;
          const hoverAr = parseFloat(imageLink.dataset.hoverAr) || 1.25;

          if (!hoverSrc) return;

          hoverLoaded = true;

          const hoverDiv = document.createElement('div');
          hoverDiv.className = 'product--hover-image';
          hoverDiv.setAttribute('data-item', 'image');

          const style = [
            '--aspect-ratio:' + hoverAr,
            '--mobile-aspect-ratio:' + hoverAr,
            '--focal-point:50% 50%',
            '--mobile-focal-point:50% 50%',
            '--image-width:100%'
          ].join(';');

          hoverDiv.innerHTML =
            '<div class="image--root" style="' + style + '">' +
              '<div class="image--container">' +
                '<picture class="image--wrapper">' +
                  '<img class="dc_img" src="' + hoverSrc + '" alt="" loading="lazy">' +
                '</picture>' +
              '</div>' +
            '</div>';

          imageLink.appendChild(hoverDiv);
        });
      });
    }

    applyColorSwatches() {
      const colorSwatches = document.querySelectorAll('.swatch-color[data-color]');

      colorSwatches.forEach(swatch => {
        const colorName = swatch.dataset.color;
        if (!colorName) return;

        const colorKey = colorName.toLowerCase().replace(/\s+/g, '');

        if (window.theme?.swatches?.[colorKey]) {
          const swatchValue = window.theme.swatches[colorKey];

          if (swatchValue.indexOf('cdn.shopify.com') > -1) {
            swatch.style.backgroundImage = `url(${swatchValue})`;
          } else {
            swatch.style.backgroundColor = swatchValue;
          }
        }
      });
    }
  }

  new ProductSwatches();
})();
